import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Admin.css";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";

import axios from "axios";
import Loader from "../components/Loader";
import CsvExportButton from "./components/CsvExportButton";

const Users = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  // const [itemsPerPage, setItemsPerPage] = useState(20);
  const isSmallScreen = window.innerWidth <= 768;

  const fields = [
    // { header: 'ID', accessor: '_id' },
    { header: 'Firstname', accessor: 'firstname' },
    { header: 'Surname', accessor: 'surname' },
    { header: 'Email address', accessor: 'email' },
    { header: 'Contact', accessor: 'contact' },
  ];

  const getFiltersFromQueryParams = (queryParams) => {
    const filters = {};
    queryParams.forEach((value, key) => {
      if (value === "true") {
        filters[key] = true;
      } else if (value === "false") {
        filters[key] = false;
      } else {
        filters[key] = value;
      }
    });
    return filters;
  };
  
  const applyFilters = (data, filters) => {
    return data.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        return item[key] === value;
      });
    });
  };


  useEffect(() => {
    document.title = "Users | BarterFunds";
    const queryParams = new URLSearchParams(location.search);
    const filters = getFiltersFromQueryParams(queryParams);

    const token = window.sessionStorage.getItem("token");

    if (!token) {
      navigate('/login');
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    axios
      .get(`${process.env.REACT_APP_API_URL}/users`, { headers: headers })
      // .get(`${process.env.REACT_APP_API_URL}/users`, { headers, params: filters })
      .then((response) => {
        if (response.data.success) {
          const sortedUsers = applyFilters(response.data.users, filters).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

          setUsers(sortedUsers);
          setIsLoading(false);
        } else {
          setUsers([]);
        }
      })
      .catch((error) => {
          if (error.response && error.response.status === 401) {
        window.sessionStorage.clear();
        navigate("/login");
      }
      });
  }, [navigate, location.search]);




  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const filteredData = users.filter(
    (user) =>
      user.firstname.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.surname.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.contact.includes(searchTerm.toLowerCase())
  );

  // Calculate pagination
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Calculate the index range of items for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  // Get the data for the current page
  const currentPageData = filteredData.slice(startIndex, endIndex);

  // Pagination handlers
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatDate = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const formatTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const amPM = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // Convert hours from 24-hour to 12-hour format
    hours = hours.toString().padStart(2, "0");

    return `${hours}:${minutes} ${amPM}`;
  };

  return (
    <div className="page-wrapper default-version">
      <AdminSidebar active={"users"} />
      <AdminHeader />

      {isLoading ? (
        <Loader />
      ) : (
        <div className="body-wrapper">
          <div className="bodywrapper__inner">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="page-title" style={{ display: isSmallScreen ? "none" : "block" }}>Users: {filteredData.length} </h6>

              <div className="d-flex flex-wrap justify-content-end align-items-center breadcrumb-plugins">
                {/* <div className="input-group w-auto flex-fill">
                  <input
                    type="search"
                    name="search"
                    className="form-control bg--white text-white"
                    placeholder="Username / Email / Contact"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  <button className="btn btn--primary" type="submit">
                    <i className="la la-search" />
                  </button>
                </div> */}
                <CsvExportButton data={filteredData} filename={"users.csv"} fields={fields} />
              </div>

              <div className="d-flex flex-wrap justify-content-end align-items-center breadcrumb-plugins" style={{ marginLeft: isSmallScreen ? "10px" : "" }}>
                <div className="input-group w-auto flex-fill">
                  <input
                    type="search"
                    name="search"
                    className="form-control bg--white text-white"
                    placeholder="Username / Email / Contact"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  <button className="btn btn--primary" type="submit">
                    <i className="la la-search" />
                  </button>
                </div>
              </div>
            </div>

            

            <div className="row mt-3">
              <div className="col-lg-12">
                <div className="card b-radius--10 ">
                  <div className="card-body p-0">
                    <div className="table-responsive--md  table-responsive">
                      <table
                        className="table table--light style--two table-responsive"
                        id="users"
                      >
                        <thead>
                          <tr>
                            <th>User</th>
                            <th>Email/Contact</th>
                            <th>Joined At</th>
                            <th>Last Login</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentPageData.length === 0 ? (
                            <tr>
                              <td colSpan="8">No data</td>{" "}
                            </tr>
                          ) : (
                            currentPageData.map((user) => (
                              <tr key={user._id}>
                                <td>
                                  <span className="fw-bold">
                                    {user.firstname} {user.surname}
                                  </span>
                                  <br />
                                  <span className="small">
                                    <a href={`users/details/${user._id}`}>
                                      <span>@</span>
                                      {user.username}
                                    </a>
                                  </span>
                                </td>
                                <td>{user.email}<br />
                                {user.contact}
                                </td>

                               
                                <td>
                                  {formatDate(user.createdAt)} <br />
                                  {formatTime(user.createdAt)}
                                </td>
                                <td>
                                  {user.lastLogin ? formatDate(user.lastLogin) : 'Not Logged In'} <br />
                                  {user.lastLogin ? formatTime(user.lastLogin) : 'Not Logged In'}
                                </td>
                                <td>
                                  
                                  {user.status === "active" ? (
                                    <span className="badge badge--success">
                                      Active
                                    </span>
                                  ) : user.status === "blocked" ? (
                                    <span className="badge badge--warning">
                                      Blocked
                                    </span>
                                  ) : (
                                    <span className="badge badge--danger">
                                      Inactive
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <a
                                    href={`/admin/users/details/${user._id}`}
                                    className="btn btn-sm btn-outline--primary"
                                  >
                                    <i className="las la-desktop" />
                                    Details{" "}
                                  </a>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {currentPageData.length === 0 ? (
                  <p></p>
                ) : (
                  <div className="card-footer py-4">
                    <nav>
                      <ul className="pagination">
                        {/* Previous Button */}
                        <li
                          className="page-item"
                          onClick={() => goToPage(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          <button className="page-link" disabled={currentPage === 1}>
                            «
                          </button>
                        </li>
                
                        {/* First Page */}
                        {currentPage > 2 && (
                          <li className="page-item">
                            <button className="page-link" onClick={() => goToPage(1)}>
                              1
                            </button>
                          </li>
                        )}
                
                        {/* Ellipsis for pages before current */}
                        {currentPage > 3 && (
                          <li className="page-item disabled">
                            <button className="page-link">...</button>
                          </li>
                        )}
                
                        {/* Dynamic page links around current page */}
                        {[...Array(totalPages)]
                          .map((_, index) => index + 1)
                          .filter(
                            (page) =>
                              page === currentPage ||
                              page === currentPage - 1 ||
                              page === currentPage + 1
                          )
                          .map((page) => (
                            <li
                              key={page}
                              className={`page-item ${
                                page === currentPage ? "active" : ""
                              }`}
                            >
                              <button className="page-link" onClick={() => goToPage(page)}>
                                {page}
                              </button>
                            </li>
                          ))}
                
                        {/* Ellipsis for pages after current */}
                        {currentPage < totalPages - 2 && (
                          <li className="page-item disabled">
                            <button className="page-link">...</button>
                          </li>
                        )}
                
                        {/* Last Page */}
                        {currentPage < totalPages - 1 && (
                          <li className="page-item">
                            <button className="page-link" onClick={() => goToPage(totalPages)}>
                              {totalPages}
                            </button>
                          </li>
                        )}
                
                        {/* Next Button */}
                        <li
                          className="page-item"
                          onClick={() => goToPage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          <button
                            className="page-link"
                            disabled={currentPage === totalPages}
                          >
                            »
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Users;
